// MCS Form Configurations — each form is defined as sections of fields
// Field types: text, textarea, number, select, checkbox, date, heading

export const MCS_FORMS = {
  "mcs-solar-pv-install": {
    title: "Solar PV Installation Checklist",
    type: "mcs_solar_pv_install",
    sections: [
      { title: "General Equipment Compliance", fields: [
        { id: "eq_standards", label: "Equipment compliant with standards, correctly selected and not damaged", type: "checkbox" },
        { id: "eq_accessible", label: "Equipment accessible for operation, inspection and maintenance", type: "checkbox" },
        { id: "eq_connected", label: "Equipment and accessories correctly connected", type: "checkbox" },
        { id: "eq_special_loc", label: "Particular protective measures for special location", type: "checkbox" },
        { id: "eq_external", label: "Equipment and protective measures appropriate to external influences", type: "checkbox" },
        { id: "eq_detrimental", label: "System installed to prevent mutual detrimental influence", type: "checkbox" },
        { id: "cond_connected", label: "Conductors connected and identified", type: "checkbox" },
        { id: "cond_capacity", label: "Conductors selected for current carrying capacity and voltage drop", type: "checkbox" },
        { id: "cond_safe_zone", label: "Conductors routed in safe zone or protected against mechanical damage", type: "checkbox" },
        { id: "fire_barriers", label: "Presence of fire barriers, seals and protection against thermal effects", type: "checkbox" },
        { id: "ventilation", label: "Ventilation provided behind array to prevent overheating/fire risk", type: "checkbox" },
        { id: "frame_corrosion", label: "Array frame and material corrosion proof", type: "checkbox" },
        { id: "frame_fixed", label: "Array frame correctly fixed and stable; roof fittings weatherproof", type: "checkbox" },
        { id: "cable_entry", label: "Cable entry weatherproof", type: "checkbox" },
        { id: "live_parts", label: "Live parts insulated, protected by barrier/enclosure, placed out of reach or Class II", type: "checkbox" },
        { id: "bonding", label: "Array frame equipotential bonding present (if required)", type: "checkbox" },
        { id: "spd", label: "Surge protection devices present (if required)", type: "checkbox" },
        { id: "rcd", label: "RCD provided (if required)", type: "checkbox" },
        { id: "lps", label: "Frame correctly integrated with existing LPS installation", type: "checkbox" },
        { id: "roof_type", label: "Roof type", type: "select", options: ["Pitched Roof", "In-roof", "Flat Roof", "Ground Mount"] },
        { id: "ac_dc_sep", label: "Physical separation of AC and DC cables", type: "checkbox" },
        { id: "dc_switch", label: "DC switch disconnect fitted (to IEC60364-712.536.2.2)", type: "checkbox" },
        { id: "dc_insulation", label: "DC cables — protective and reinforced insulation (if required)", type: "checkbox" },
        { id: "dc_rated", label: "All DC components rated for max DC system voltage (Voc stc x 1.25)", type: "checkbox" },
        { id: "strings_fused", label: "PV strings fused or blocking diodes fitted (if required)", type: "checkbox" },
        { id: "ac_isolator", label: "AC Isolator lockable in off position only", type: "checkbox" },
        { id: "gen_meter", label: "Generation Meter readable without torch or ladder and sealed", type: "checkbox" },
        { id: "inverter_settings", label: "Inverter protection settings to local regulations", type: "checkbox" },
      ]},
      { title: "Labelling & Documentation", fields: [
        { id: "circuit_labels", label: "General labelling of circuits, protective devices, switches and terminals", type: "checkbox" },
        { id: "schematic", label: "PV system schematic displayed on site", type: "checkbox" },
        { id: "installer_details", label: "Protection settings and installer details displayed on site", type: "checkbox" },
        { id: "shutdown_proc", label: "Emergency shutdown procedure displayed on site", type: "checkbox" },
        { id: "ac_label", label: "AC Isolator clearly labelled", type: "checkbox" },
        { id: "dc_label", label: "DC isolator/junction boxes suitably labelled", type: "checkbox" },
        { id: "signs_durable", label: "Signs and labels suitably affixed and durable", type: "checkbox" },
        { id: "dno_info", label: "DNO information collected", type: "checkbox" },
        { id: "pv_report", label: "PV Array Report completed", type: "checkbox" },
        { id: "building_control", label: "Notification to Building Control/electrical certificates completed", type: "checkbox" },
      ]},
    ],
  },

  "mcs-solar-pv-commissioning": {
    title: "Solar PV Commissioning Checklist",
    type: "mcs_solar_pv_commissioning",
    sections: [
      { title: "System Information", fields: [
        { id: "module_make", label: "PV Module make & model", type: "text" },
        { id: "module_count", label: "Number of modules", type: "number" },
        { id: "module_wp", label: "Module rated power (Wp)", type: "number" },
        { id: "total_kwp", label: "Total array capacity (kWp)", type: "number" },
        { id: "inverter_make", label: "Inverter make & model", type: "text" },
        { id: "inverter_rating", label: "Inverter rated power (kW)", type: "number" },
        { id: "orientation", label: "Array orientation", type: "text", placeholder: "e.g. South" },
        { id: "tilt", label: "Array tilt angle (degrees)", type: "number" },
      ]},
      { title: "Pre-Commissioning Checks", fields: [
        { id: "visual_ok", label: "Visual inspection of all components satisfactory", type: "checkbox" },
        { id: "mech_secure", label: "All mechanical fixings secure", type: "checkbox" },
        { id: "labels_ok", label: "All labels and signs in place", type: "checkbox" },
        { id: "dc_isolator_ok", label: "DC isolator tested and operational", type: "checkbox" },
        { id: "ac_isolator_ok", label: "AC isolator tested and operational", type: "checkbox" },
        { id: "earth_ok", label: "Earthing/bonding verified", type: "checkbox" },
      ]},
      { title: "Electrical Test Results", fields: [
        { id: "voc_string1", label: "String 1 — Open circuit voltage Voc (V)", type: "text" },
        { id: "isc_string1", label: "String 1 — Short circuit current Isc (A)", type: "text" },
        { id: "voc_string2", label: "String 2 — Voc (V)", type: "text" },
        { id: "isc_string2", label: "String 2 — Isc (A)", type: "text" },
        { id: "ir_dc_pos_earth", label: "Insulation resistance DC+ to Earth (MΩ)", type: "text" },
        { id: "ir_dc_neg_earth", label: "Insulation resistance DC- to Earth (MΩ)", type: "text" },
        { id: "earth_continuity", label: "Earth continuity (Ω)", type: "text" },
        { id: "irradiance", label: "Irradiance at time of test (W/m²)", type: "text" },
        { id: "module_temp", label: "Module temperature at test (°C)", type: "text" },
      ]},
      { title: "Commissioning Verification", fields: [
        { id: "inverter_on", label: "Inverter powered on and generating", type: "checkbox" },
        { id: "gen_meter_ok", label: "Generation meter reading and recording", type: "checkbox" },
        { id: "export_ok", label: "Export meter verified (if applicable)", type: "checkbox" },
        { id: "monitoring_ok", label: "Monitoring system active and communicating", type: "checkbox" },
        { id: "g98_compliant", label: "G98/G99 settings verified", type: "checkbox" },
        { id: "customer_demo", label: "System demonstrated to customer", type: "checkbox" },
      ]},
    ],
  },

  "mcs-solar-pv-array-test": {
    title: "Solar PV Array Test Form",
    type: "mcs_solar_pv_array_test",
    hasDynamicStrings: true,
    maxStrings: 15,
    sections: [
      { title: "Array Configuration", fields: [
        { id: "array_location", label: "Array location", type: "text" },
        { id: "module_type", label: "Module type", type: "text" },
        { id: "num_strings", label: "Number of strings", type: "number" },
        { id: "total_modules", label: "Total number of modules", type: "number" },
      ]},
      { title: "Test Conditions", fields: [
        { id: "test_irradiance", label: "Irradiance (W/m²)", type: "text" },
        { id: "test_temp", label: "Ambient temperature (°C)", type: "text" },
        { id: "test_cell_temp", label: "Cell temperature (°C)", type: "text" },
        { id: "earth_continuity", label: "Earth continuity of frame (Ω)", type: "text" },
        { id: "polarity_ok", label: "Polarity verified", type: "checkbox" },
        { id: "string_match", label: "String voltages within expected range", type: "checkbox" },
      ]},
    ],
  },

  "mcs-solar-pv-handover": {
    title: "Solar PV Handover Document",
    type: "mcs_solar_pv_handover",
    sections: [
      { title: "PV System Description", fields: [
        { id: "rated_power", label: "Rated power (kW DC)", type: "text" },
        { id: "estimated_performance", label: "Estimated annual performance (kWh)", type: "text" },
        { id: "location", label: "Array location", type: "text" },
        { id: "iec_inspection_ref", label: "IEC 60364-6 inspection report reference", type: "text" },
        { id: "iec_test_ref", label: "IEC 60364-6 test report reference", type: "text" },
        { id: "pv_inspection_ref", label: "PV array inspection report reference", type: "text" },
        { id: "pv_test_ref", label: "PV array test report reference", type: "text" },
        { id: "circuits_tested", label: "Circuits tested", type: "text" },
      ]},
      { title: "Declaration", fields: [
        { id: "next_inspection", label: "Next inspection recommended after (years)", type: "text" },
        { id: "handover_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },

  "mcs-solar-pv-battery-handover": {
    title: "Solar PV & Battery Handover Document",
    type: "mcs_solar_pv_battery_handover",
    sections: [
      { title: "Verification Type", fields: [
        { id: "verification_type", label: "Verification type", type: "select", options: ["Initial verification", "Periodic verification"] },
      ]},
      { title: "EESS Description", fields: [
        { id: "system_class", label: "System Class (MIS 3012 Section 2.2)", type: "select", options: ["1", "2", "3", "4"] },
        { id: "island_mode", label: "Island Mode capable?", type: "select", options: ["Yes", "No"] },
        { id: "max_power", label: "Max power output (kW)", type: "text" },
        { id: "usable_capacity", label: "Usable capacity (kWh)", type: "text" },
      ]},
      { title: "PV Description", fields: [
        { id: "rated_power", label: "Rated power (kW DC)", type: "text" },
        { id: "estimated_performance", label: "Estimated system performance (kWh)", type: "text" },
        { id: "location", label: "Location", type: "text" },
        { id: "iec_inspection_ref", label: "IEC 60364-6 inspection report reference", type: "text" },
        { id: "iec_test_ref", label: "IEC 60364-6 test report reference", type: "text" },
        { id: "pv_inspection_ref", label: "PV array inspection report reference", type: "text" },
        { id: "pv_test_ref", label: "PV array test report reference", type: "text" },
      ]},
      { title: "Declaration", fields: [
        { id: "next_inspection", label: "Next inspection recommended after (years)", type: "text" },
        { id: "handover_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },

  "mcs-battery-handover": {
    title: "Battery Handover Document",
    type: "mcs_battery_handover",
    sections: [
      { title: "Verification Type", fields: [
        { id: "verification_type", label: "Verification type", type: "select", options: ["Initial verification", "Periodic verification"] },
      ]},
      { title: "EESS Description", fields: [
        { id: "system_class", label: "System Class (MIS 3012 Section 2.2)", type: "select", options: ["1", "2", "3", "4"] },
        { id: "island_mode", label: "Island Mode capable?", type: "select", options: ["Yes", "No"] },
        { id: "max_power", label: "Max power output (kW)", type: "text" },
        { id: "usable_capacity", label: "Usable capacity (kWh)", type: "text" },
        { id: "comm_cert_1", label: "Commissioning certificate part 1 (F74)", type: "checkbox" },
        { id: "comm_cert_2", label: "Commissioning certificate part 2 (F74)", type: "checkbox" },
        { id: "comm_cert_3", label: "Commissioning certificate part 3 (F75)", type: "checkbox" },
        { id: "comm_cert_4", label: "Commissioning certificate part 4 (F75)", type: "checkbox" },
      ]},
      { title: "Declaration", fields: [
        { id: "next_inspection", label: "Next inspection recommended after (years)", type: "text" },
        { id: "handover_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },

  "mcs-battery-commissioning": {
    title: "Battery Commissioning Checklist",
    type: "mcs_battery_commissioning",
    sections: [
      { title: "Equipment & Systems Tests", fields: [
        { id: "data_acq", label: "Data acquisition and control systems performing correctly", type: "checkbox" },
        { id: "internet", label: "EESS correctly configured and communicating (internet)", type: "checkbox" },
        { id: "displays", label: "User displays and alarm mechanisms functioning correctly", type: "checkbox" },
        { id: "charge_discharge", label: "EESS charge and discharge functions operating correctly", type: "checkbox" },
        { id: "thermal_mgmt", label: "Thermal management systems functioning correctly", type: "checkbox" },
        { id: "ventilation_sys", label: "Ventilation systems and controls functioning correctly", type: "checkbox" },
        { id: "fire_systems", label: "Fire detection/management systems functioning correctly", type: "checkbox" },
        { id: "wet_chemical", label: "Wet chemical checks — liquids within EESS validated", type: "checkbox" },
        { id: "ancillary", label: "Ancillary equipment functioning correctly (pumps, valves, etc.)", type: "checkbox" },
      ]},
      { title: "Application Tests", fields: [
        { id: "g98_g99", label: "G98/G99 — loss of mains test completed (grid connected)", type: "checkbox" },
        { id: "export_limit", label: "Export limitation (G100) tests completed (if applicable)", type: "checkbox" },
        { id: "ancillary_services", label: "Ancillary grid services tests completed (if applicable)", type: "checkbox" },
        { id: "revenue_metering", label: "Revenue metering/monitoring verified", type: "checkbox" },
        { id: "backup_quality", label: "Back-up/island mode power quality verified", type: "checkbox" },
        { id: "changeover_switches", label: "Changeover switches/relays functioning correctly", type: "checkbox" },
        { id: "ne_switching", label: "Neutral-earth switching functioning correctly", type: "checkbox" },
        { id: "essential_sep", label: "Essential and non-essential supplies correctly separated", type: "checkbox" },
        { id: "earth_electrode", label: "Earth electrode resistance measured (consumer's electrode)", type: "checkbox" },
      ]},
    ],
  },

  "mcs-battery-testing": {
    title: "Battery Testing Checklist",
    type: "mcs_battery_testing",
    sections: [
      { title: "Design & Equipment", fields: [
        { id: "design_ok", label: "System installed in accordance with design", type: "checkbox" },
        { id: "equipment_ok", label: "Equipment correctly selected and erected per standards", type: "checkbox" },
        { id: "undamaged", label: "Equipment undamaged", type: "checkbox" },
        { id: "conductors_ok", label: "Conductors correctly connected, identified and routed", type: "checkbox" },
        { id: "cond_rated", label: "Conductors suitably selected for voltage and current", type: "checkbox" },
        { id: "switchgear_rated", label: "Switchgear suitable for voltage and current requirements", type: "checkbox" },
        { id: "switchgear_installed", label: "Switchgear correctly installed and connected", type: "checkbox" },
        { id: "external_influences", label: "Components selected for locations and external influences", type: "checkbox" },
      ]},
      { title: "Protection Against Electric Shock", fields: [
        { id: "insulation", label: "Protection by insulation of live parts — suitable", type: "checkbox" },
        { id: "barriers", label: "Protection by barriers/enclosures — suitable IP rating", type: "checkbox" },
        { id: "rcd_30ma", label: "Additional protection by RCD ≤ 30mA", type: "checkbox" },
        { id: "supp_bonding", label: "Supplementary bonding", type: "checkbox" },
        { id: "main_earth", label: "Suitable main earth provided", type: "checkbox" },
        { id: "earth_connections", label: "Earth connections suitably installed", type: "checkbox" },
        { id: "main_bonding", label: "Main protective bonding suitably installed", type: "checkbox" },
        { id: "rcd_fault", label: "RCDs provided for fault protection (where necessary)", type: "checkbox" },
      ]},
      { title: "EESS Location & Equipment", fields: [
        { id: "location_ventilation", label: "Location has suitable ventilation for EESS", type: "checkbox" },
        { id: "location_ip", label: "Location suitable for IP rating of EESS components", type: "checkbox" },
        { id: "fire_measures", label: "Fire prevention and detection measures implemented", type: "checkbox" },
        { id: "safety_signs", label: "Site safety signs displayed and durable", type: "checkbox" },
        { id: "manuf_req", label: "Equipment installed to manufacturer's requirements", type: "checkbox" },
        { id: "clearance", label: "Clearance from adjacent objects meets manufacturer's specs", type: "checkbox" },
        { id: "equip_ventilation", label: "Ventilation of equipment meets requirements", type: "checkbox" },
        { id: "heat_clearance", label: "Clearance from external heat sources acceptable", type: "checkbox" },
        { id: "accessible", label: "EESS equipment accessible for maintenance and operation", type: "checkbox" },
        { id: "eess_labels", label: "EESS labelling displayed and durable", type: "checkbox" },
      ]},
      { title: "Circuit Test Results", fields: [
        { id: "earth_continuity", label: "Continuity of earthing/bonding conductors verified", type: "checkbox" },
        { id: "earth_terminal", label: "Connection to main earthing terminal verified", type: "checkbox" },
        { id: "ir_test", label: "Insulation resistance test completed (all AC and DC circuits)", type: "checkbox" },
        { id: "polarity_test", label: "Polarity test — all circuits correctly marked and connected", type: "checkbox" },
        { id: "earth_electrode_r", label: "Earth electrode resistance tested (where fitted)", type: "checkbox" },
        { id: "efli", label: "Earth fault loop impedance of individual circuits determined", type: "checkbox" },
        { id: "efli_ok", label: "EFLI values allow protective device clearance within time", type: "checkbox" },
        { id: "rcd_test", label: "RCD function test completed", type: "checkbox" },
        { id: "functional_switch", label: "Switchgear and circuit devices operate correctly", type: "checkbox" },
        { id: "functional_island", label: "Island mode isolator switching functions correctly", type: "checkbox" },
      ]},
    ],
  },

  "mcs-heat-pump-commissioning": {
    title: "Heat Pump Commissioning Checklist",
    type: "mcs_heat_pump_commissioning",
    sections: [
      { title: "Product Information", fields: [
        { id: "hp_type", label: "Heat pump type", type: "select", options: ["ASHP", "GSHP"] },
        { id: "hp_model", label: "Heat pump model number", type: "text" },
        { id: "hp_serial", label: "Serial number", type: "text" },
        { id: "indoor_model", label: "Indoor model number", type: "text" },
        { id: "indoor_serial", label: "Indoor serial number", type: "text" },
        { id: "interface_model", label: "Interface model number", type: "text" },
        { id: "interface_serial", label: "Interface serial number", type: "text" },
      ]},
      { title: "Pre-Commissioning Electrical", fields: [
        { id: "supply_type", label: "Electrical supply", type: "select", options: ["Single phase", "Three phase"] },
        { id: "resistance_earth", label: "Resistance to earth L-E (Ω)", type: "text" },
        { id: "short_circuit", label: "Short circuit test L-N (Ω)", type: "text" },
        { id: "visual_condition", label: "Visual condition of installation", type: "text" },
        { id: "mfr_instructions", label: "Installed as per manufacturer's instructions", type: "checkbox" },
        { id: "sensors_ok", label: "All sensors checked and reading correctly", type: "checkbox" },
      ]},
      { title: "Control Parameters", fields: [
        { id: "running_mode", label: "Running mode", type: "select", options: ["Auto", "Manual", "Eco"] },
        { id: "max_flow_temp", label: "Max flow temp (°C)", type: "text" },
        { id: "min_flow_temp", label: "Min flow temp (°C)", type: "text" },
        { id: "heat_curve", label: "Heat curve setting", type: "text" },
        { id: "dhw_start", label: "DHW start (°C)", type: "text" },
        { id: "dhw_stop", label: "DHW stop (°C)", type: "text" },
        { id: "legionella_temp", label: "Legionella cycle temp (°C)", type: "text" },
        { id: "legionella_freq", label: "Legionella frequency (days)", type: "text" },
        { id: "max_demand", label: "Maximum demand (kW)", type: "text" },
      ]},
      { title: "Running Data", fields: [
        { id: "outdoor_temp", label: "Outdoor temp (°C)", type: "text" },
        { id: "flow_temp", label: "Flow temp (°C)", type: "text" },
        { id: "return_temp", label: "Return temp (°C)", type: "text" },
        { id: "source_in", label: "Source in (°C)", type: "text" },
        { id: "source_out", label: "Source out (°C)", type: "text" },
        { id: "dhw_temp", label: "DHW temp (°C)", type: "text" },
        { id: "kwh_reading", label: "kWh meter reading", type: "text" },
        { id: "heat_meter", label: "Heat meter reading (MWh)", type: "text" },
      ]},
      { title: "Heating System", fields: [
        { id: "emitter_types", label: "Emitter types", type: "text", placeholder: "e.g. UFH, radiators" },
        { id: "htg_delta_t", label: "Heating ΔT (K)", type: "text" },
        { id: "system_pressure", label: "System pressure (bar)", type: "text" },
        { id: "dhw_cylinder", label: "DHW cylinder volume (litres)", type: "text" },
        { id: "htg_flushed", label: "HTG system flushed and cleaned", type: "checkbox" },
        { id: "htg_treated", label: "HTG system water treated", type: "checkbox" },
        { id: "htg_purged", label: "HTG system purged of air", type: "checkbox" },
        { id: "g3_cert", label: "G3 commissioning certificate completed", type: "checkbox" },
        { id: "system_design", label: "System installed as per design", type: "checkbox" },
        { id: "emitters_even", label: "All emitters heat up evenly with similar ΔT", type: "checkbox" },
        { id: "controls_setup", label: "Controls set up as per design", type: "checkbox" },
        { id: "controls_demo", label: "Controls demonstrated and explained to customer", type: "checkbox" },
        { id: "docs_provided", label: "Customer provided with all MIS 3005 documentation", type: "checkbox" },
      ]},
    ],
  },

  "mcs-heat-pump-handover": {
    title: "Heat Pump Handover Certificate",
    type: "mcs_heat_pump_handover",
    sections: [
      { title: "Verification Type", fields: [
        { id: "verification_type", label: "Verification type", type: "select", options: ["Initial verification", "Periodic verification"] },
      ]},
      { title: "System Description", fields: [
        { id: "design_flow_temp", label: "Design flow temperature (°C)", type: "text" },
        { id: "system_capacity", label: "System rated capacity (kW)", type: "text" },
        { id: "annual_space", label: "Annual space heating demand per MIS 3005 (kWh)", type: "text" },
        { id: "scop", label: "Heat Pump SCoP (at design flow temperature)", type: "text" },
        { id: "annual_hot_water", label: "Annual hot water demand per MIS 3005 (kWh)", type: "text" },
      ]},
      { title: "Declaration", fields: [
        { id: "next_inspection", label: "Next inspection recommended after (years)", type: "text" },
        { id: "handover_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },

  "mcs-cylinder-commissioning": {
    title: "Cylinder Commissioning Checklist",
    type: "mcs_cylinder_commissioning",
    sections: [
      { title: "Primary Settings (Indirect Heating Only)", fields: [
        { id: "primary_type", label: "Primary circuit type", type: "select", options: ["Sealed", "Open vented", "N/A"] },
        { id: "max_primary_flow", label: "Maximum primary flow temperature (°C)", type: "text" },
      ]},
      { title: "All Systems", fields: [
        { id: "cold_pressure", label: "Incoming static cold water pressure (bar)", type: "text" },
        { id: "strainer_cleaned", label: "Strainer cleaned of installation debris (if fitted)", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "hard_water", label: "Installation in hard water area (above 200ppm)?", type: "select", options: ["Yes", "No"] },
        { id: "scale_reducer", label: "Water scale reducer fitted?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "scale_reducer_type", label: "Type of scale reducer", type: "text" },
        { id: "thermostat_temp", label: "Hot water thermostat set temperature (°C)", type: "text" },
        { id: "max_flow_rate", label: "Maximum hot water flow rate at set temp (l/min)", type: "text" },
        { id: "part_l", label: "Time & temperature controls fitted per Part L Building Regs", type: "checkbox" },
        { id: "control_type", label: "Type of control system", type: "select", options: ["Y Plan", "S Plan", "Other", "N/A"] },
        { id: "solar_compatible", label: "Cylinder solar/renewable compatible?", type: "select", options: ["Yes", "No"] },
        { id: "nearest_outlet_temp", label: "Hot water temperature at nearest outlet (°C)", type: "text" },
        { id: "pipes_insulated", label: "All appropriate pipes insulated up to 1m or point of concealment", type: "checkbox" },
      ]},
      { title: "Unvented Systems Only", fields: [
        { id: "prv_location", label: "Pressure reducing valve location (if fitted)", type: "text" },
        { id: "prv_setting", label: "Pressure reducing valve setting (bar)", type: "text" },
        { id: "tpr_tested", label: "T&P relief valve and expansion valve fitted and discharge tested", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "tundish_ok", label: "Tundish and discharge connected per Part G Building Regs", type: "checkbox" },
        { id: "cutout_ok", label: "All energy sources fitted with cut out device", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "expansion_checked", label: "Expansion vessel or internal air space checked", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Final Checks", fields: [
        { id: "building_regs", label: "Hot water system complies with appropriate Building Regs", type: "checkbox" },
        { id: "mfr_instructions", label: "System installed and commissioned per manufacturer's instructions", type: "checkbox" },
        { id: "controls_demo", label: "System controls demonstrated to and understood by customer", type: "checkbox" },
        { id: "literature_left", label: "Manufacturer's literature explained and left with customer", type: "checkbox" },
      ]},
    ],
  },

  "mcs-dno-ev-hp": {
    title: "DNO EV & HP Application",
    type: "mcs_dno_ev_hp",
    sections: [
      { title: "Section A — Contact Details", fields: [
        { id: "installer_name", label: "Installer name", type: "text" },
        { id: "installer_company", label: "Installer company", type: "text" },
        { id: "installer_address", label: "Installer address", type: "text" },
        { id: "installer_town", label: "Town", type: "text" },
        { id: "installer_postcode", label: "Postcode", type: "text" },
        { id: "installer_phone", label: "Contact number", type: "text" },
        { id: "installer_email", label: "Email", type: "text" },
        { id: "contact_customer", label: "Can we contact the customer directly?", type: "select", options: ["Yes", "No"] },
        { id: "customer_name", label: "Customer name", type: "text" },
        { id: "customer_phone", label: "Customer contact number", type: "text" },
        { id: "customer_email", label: "Customer email", type: "text" },
      ]},
      { title: "Section B — Notification Criteria", fields: [
        { id: "one_equipment", label: "Only connecting one additional piece of equipment", type: "checkbox" },
        { id: "cutout_known", label: "DNO cut-out rating known", type: "checkbox" },
        { id: "no_safety_concerns", label: "No safety concerns over integrity of DNO service equipment", type: "checkbox" },
        { id: "no_adequacy_issues", label: "No other issues with adequacy of DNO service equipment", type: "checkbox" },
        { id: "not_looped", label: "Not a Looped Service", type: "checkbox" },
        { id: "metered_supply", label: "Metered supply", type: "checkbox" },
        { id: "md_under_cutout", label: "Maximum Demand less than known cut-out rating", type: "checkbox" },
        { id: "md_under_13_8", label: "Maximum Demand < 13.8kVA per phase OR CT metered OR load limited", type: "checkbox" },
        { id: "hp_single_controller", label: "HP: Heat pump system under single controller only", type: "checkbox" },
        { id: "hp_md_32a", label: "HP: Total heat pump system Maximum Demand ≤ 32A", type: "checkbox" },
        { id: "hp_in_database", label: "HP: Model marked 'Connect and Notify' in ENA HP Database", type: "checkbox" },
        { id: "evcp_ac_output", label: "EVCP: AC Output", type: "checkbox" },
        { id: "evcp_md_ok", label: "EVCP: Premises MD ≤13.8kVA per phase OR CT ≤30% MIC", type: "checkbox" },
        { id: "notification_result", label: "Does installation meet all notification criteria?", type: "select", options: ["Yes — Notify DNO", "No — Apply before installation"] },
        { id: "date_installed", label: "Date installed", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Section C — Electricity Supply Details", fields: [
        { id: "premises_type", label: "Type of premises", type: "select", options: ["Residential house", "Residential flat", "Commercial", "Public", "Other"] },
        { id: "mpan", label: "MPAN", type: "text" },
        { id: "smart_meter", label: "Smart meter installed?", type: "select", options: ["Yes", "No"] },
        { id: "declared_voltage", label: "Declared voltage at connection point (V)", type: "text" },
        { id: "num_phases", label: "Number of phases", type: "select", options: ["Single Phase", "Three Phase", "Split/two Phase"] },
        { id: "max_demand", label: "Maximum Demand of premises (A or kVA)", type: "text" },
        { id: "supply_capacity", label: "Supply Capacity / Maximum Import Capacity", type: "text" },
        { id: "cutout_rating", label: "Premises cut-out rating (A)", type: "text" },
        { id: "load_limiting", label: "Import or load limiting device on premises?", type: "select", options: ["Yes", "No"] },
        { id: "earthing_arrangement", label: "Final/proposed earthing arrangements", type: "select", options: ["TN-C-S (PME)", "TT (Direct)", "Customer Substation", "TN-S (SNE)"] },
        { id: "service_looped", label: "Is the service looped?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Section E — Equipment to be Installed", fields: [
        { id: "equipment_type", label: "Type of equipment", type: "select", options: ["Heat Pump", "Electric Vehicle Charge Point (EVCP)", "V2G EVCP", "Heat Pump + EVCP"] },
        { id: "max_current_demand", label: "Maximum current demand of proposed equipment (A)", type: "text" },
        { id: "evcp_manufacturer", label: "EVCP/HP manufacturer", type: "text" },
        { id: "evcp_model", label: "EVCP/HP model", type: "text" },
        { id: "in_database", label: "Model in ENA database?", type: "select", options: ["Yes", "No"] },
        { id: "product_id", label: "Product ID / Register No", type: "text" },
        { id: "hp_usage", label: "Heat Pump usage", type: "select", options: ["Heating only", "Heating and cooling", "N/A"] },
        { id: "hp_backup", label: "HP back-up heater", type: "select", options: ["On-board", "External", "N/A"] },
        { id: "hp_boost", label: "HP boost heater", type: "select", options: ["On-board", "External", "N/A"] },
        { id: "hp_immersion", label: "HP immersion heater", type: "select", options: ["On-board", "External", "N/A"] },
      ]},
      { title: "Declaration", fields: [
        { id: "info_true", label: "I confirm the information given is true to the best of my knowledge", type: "checkbox" },
        { id: "customer_advised", label: "Customer advised installation may only proceed after DNO approval (if application)", type: "checkbox" },
      ]},
    ],
  },
  "mcs-ashp-benchmark": {
    type: "ashp_benchmark",
    title: "Air Source Heat Pump Commissioning Benchmark",
    description: "HHIC Benchmark commissioning checklist for air-to-water heat pump installations",
    sections: [
      { title: "Installation Address & Heat Pump Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "hp_type", label: "Heat Pump Type", type: "select", options: ["Split", "Monoblock"] },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
        { id: "hp_cascade", label: "Is Heat Pump installed as part of a cascade?", type: "select", options: ["Yes", "No"] },
        { id: "hp_cascade_series", label: "Cascade Heat Pump Series (e.g. 1 of 2)", type: "text" },
        { id: "hp_refrigerant_type", label: "Heat Pump Refrigerant Type", type: "text" },
        { id: "hp_refrigerant_weight", label: "Refrigerant weight total (kg)", type: "text" },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "cert_operative_reg", label: "Certified Operative Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "company_email", label: "Company email", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Compliance & Registration", fields: [
        { id: "building_regs_compliant", label: "Heating and hot water system complies with appropriate Building Regulations?", type: "select", options: ["Yes", "No"] },
        { id: "dno_notification", label: "DNO notification?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "building_reg_number", label: "Building Regulations Notification Number (if applicable)", type: "text" },
        { id: "mcs_installer_reg", label: "MCS installer registration Number (if applicable)", type: "text" },
        { id: "mcs_product_cert", label: "MCS product certification number (if applicable)", type: "text" },
        { id: "fgas_cert", label: "F-gas certification number (split heat pump only)", type: "text" },
        { id: "g3_cert", label: "G3 certification number (if applicable)", type: "text" },
      ]},
      { title: "Electrical and Hydronic Controls — SYSTEM AND HEAT PUMP", fields: [
        { id: "ctrl_time_temp_heating", label: "Time and temperature control to heating", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_prog_roomstat", label: "Programmable Roomstat", type: "checkbox" },
        { id: "ctrl_load_weather", label: "Load/weather compensation", type: "checkbox" },
        { id: "ctrl_optimum_start", label: "Optimum start control", type: "checkbox" },
        { id: "ctrl_time_temp_hw", label: "Time and temperature control to hot water", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_combined_hp", label: "Combined with Heat pump main controls", type: "checkbox" },
        { id: "ctrl_hybrid", label: "Hybrid system — synchronised control of boiler and heat pump fitted", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "ctrl_hybrid_switching", label: "If Yes — boiler model switching point (Quote Tariff or Temperature Level)", type: "text" },
      ]},
      { title: "Zone Valves & Components", fields: [
        { id: "heating_zone_status", label: "Heating zone valves (including underfloor loops)", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hw_zone_status", label: "Hot water zone valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "trv_status", label: "Thermostatic radiator valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "outdoor_sensor_status", label: "Outdoor Sensor", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hp_safety_interlock", label: "Heat Pump Safety Interlock", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "auto_bypass_status", label: "Automatic bypass to system", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "buffer_vessel", label: "Buffer Vessel Fitted", type: "select", options: ["Yes", "No"] },
        { id: "buffer_vessel_volume", label: "Buffer vessel volume (Litres)", type: "text" },
        { id: "plate_heat_exchanger", label: "Plate Heat Exchanger fitted for hydronic separation of heat pump circuit to heating circuit", type: "select", options: ["Yes", "No"] },
        { id: "expansion_vessel", label: "Expansion vessel for heating sized, fitted & charged per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "legionella_protection", label: "Legionella protection for stored hot water provided by timed temperature control?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Water Treatment — SYSTEM AND HEAT PUMP", fields: [
        { id: "system_cleaned_bs7593", label: "System cleaned and treated in accordance with BS 7593:2019 and heat pump manufacturer's instructions?", type: "select", options: ["Yes", "No"] },
        { id: "system_cleaner_brand", label: "System cleaner — Brand", type: "text" },
        { id: "system_cleaner_product", label: "System cleaner — Product", type: "text" },
        { id: "inhibitor_brand", label: "Heating system inhibitor — Brand", type: "text" },
        { id: "inhibitor_product", label: "Heating system inhibitor — Product", type: "text" },
        { id: "antifreeze_brand", label: "Anti-freeze/inhibitor (monoblock only) — Brand", type: "text" },
        { id: "antifreeze_product", label: "Anti-freeze/inhibitor — Product", type: "text" },
        { id: "antifreeze_concentration", label: "Anti-freeze/inhibitor — % concentration", type: "text" },
        { id: "system_filter_bs7593", label: "System filter fitted in accordance with BS7593:2019?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Heat Pump Outdoor Unit", fields: [
        { id: "frost_protected", label: "Heating system adequately frost protected and pipes insulated to prevent heat loss?", type: "select", options: ["Yes", "No"] },
        { id: "refrigerant_evacuated", label: "Split only: Refrigerant circuit evacuated and charged per manufacturer's instructions", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "solid_surface", label: "Heat pump fitted on solid/stable surface capable of taking its weight", type: "select", options: ["Yes", "No"] },
        { id: "defrost_provision", label: "Necessary heat pump defrost provision put in place", type: "select", options: ["Yes", "No"] },
        { id: "fan_clear", label: "Heat pump fan free from obstacles and operational", type: "select", options: ["Yes", "No"] },
        { id: "condensate_drain", label: "Condensate drain installed to manufacturer's instructions", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Central Heating Mode", fields: [
        { id: "ch_filled_tested", label: "Heating system has been filled and pressure tested", type: "select", options: ["Yes", "No"] },
        { id: "ch_flow_temp", label: "Heating Flow Temperature (°C)", type: "text" },
        { id: "ch_return_temp", label: "Heating Return Temperature (°C)", type: "text" },
        { id: "ch_balanced", label: "System correctly balanced/rebalanced", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Domestic Hot Water Mode", fields: [
        { id: "dhw_cylinder_type", label: "Is the heat pump connected to a hot water cylinder?", type: "select", options: ["Unvented", "Vented", "Thermal Store", "Not connected"] },
        { id: "dhw_cylinder_size", label: "Hot water cylinder size (Litres)", type: "text" },
        { id: "dhw_stored_temp", label: "Stored hot water temperature (°C)", type: "text" },
        { id: "dhw_checked_all_outlets", label: "Hot water has been checked at all outlets", type: "select", options: ["Yes", "No"] },
        { id: "dhw_blending_valves", label: "Have Thermostatic Blending Valves been fitted?", type: "select", options: ["Yes", "Not required"] },
      ]},
      { title: "Additional System Information", fields: [
        { id: "water_flow_rate", label: "Water flow rate setting of the heat pump at commissioning (l/min)", type: "text" },
        { id: "additional_gas_boiler", label: "Additional heat source: Gas Boiler", type: "checkbox" },
        { id: "additional_oil_boiler", label: "Additional heat source: Oil Boiler", type: "checkbox" },
        { id: "additional_electric_heater", label: "Additional heat source: Electric Heater", type: "checkbox" },
        { id: "additional_solar_thermal", label: "Additional heat source: Solar Thermal", type: "checkbox" },
        { id: "additional_other", label: "Additional heat source: Other", type: "text" },
      ]},
      { title: "All Installations — Compliance Declarations", fields: [
        { id: "decl_electrical", label: "All electrical work complies with the appropriate Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "Heat pump and associated products installed and commissioned per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation of heat pump and system controls demonstrated to and understood by customer", type: "select", options: ["Yes", "No"] },
        { id: "decl_literature", label: "Manufacturer's literature, including Benchmark Checklist and Service Record, explained and left with customer", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Service Record 1", fields: [
        { id: "svc1_engineer", label: "Engineer name", type: "text" },
        { id: "svc1_company", label: "Company name", type: "text" },
        { id: "svc1_telephone", label: "Telephone No", type: "text" },
        { id: "svc1_operative_id", label: "Operative ID No", type: "text" },
        { id: "svc1_date", label: "Date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "svc1_inhibitor_checked", label: "System inhibitor concentration checked and appropriate action taken per BS 7593", type: "select", options: ["Yes", "N/a"] },
        { id: "svc1_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "mcs-gshp-benchmark": {
    type: "gshp_benchmark",
    title: "Ground Source Heat Pump Commissioning Benchmark",
    description: "HHIC Benchmark commissioning checklist for ground source heat pump installations",
    sections: [
      { title: "Installation Address & Heat Pump Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "hp_type", label: "Heat Pump Type", type: "select", options: ["Ground Source (Horizontal)", "Ground Source (Vertical/Borehole)", "Water Source"] },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
        { id: "hp_refrigerant_type", label: "Heat Pump Refrigerant Type", type: "text" },
        { id: "hp_refrigerant_weight", label: "Refrigerant weight total (kg)", type: "text" },
      ]},
      { title: "Ground Loop / Collector Details", fields: [
        { id: "loop_type", label: "Ground loop type", type: "select", options: ["Horizontal slinky", "Horizontal straight", "Vertical borehole", "Open loop", "Pond/Lake"] },
        { id: "loop_length", label: "Total loop length (m)", type: "text" },
        { id: "loop_depth", label: "Loop depth / borehole depth (m)", type: "text" },
        { id: "loop_pipe_diameter", label: "Loop pipe diameter (mm)", type: "text" },
        { id: "loop_pipe_material", label: "Loop pipe material", type: "select", options: ["HDPE", "MDPE", "Copper", "Other"] },
        { id: "loop_antifreeze_type", label: "Antifreeze / glycol type", type: "text" },
        { id: "loop_antifreeze_concentration", label: "Antifreeze concentration (%)", type: "text" },
        { id: "loop_flow_rate", label: "Ground loop flow rate (l/min)", type: "text" },
        { id: "loop_pressure_tested", label: "Ground loop pressure tested?", type: "select", options: ["Yes", "No"] },
        { id: "loop_test_pressure", label: "Test pressure (bar)", type: "text" },
        { id: "loop_flushed", label: "Ground loop flushed and filled?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "cert_operative_reg", label: "Certified Operative Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "company_email", label: "Company email", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Compliance & Registration", fields: [
        { id: "building_regs_compliant", label: "Heating and hot water system complies with appropriate Building Regulations?", type: "select", options: ["Yes", "No"] },
        { id: "dno_notification", label: "DNO notification?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "building_reg_number", label: "Building Regulations Notification Number (if applicable)", type: "text" },
        { id: "mcs_installer_reg", label: "MCS installer registration Number (if applicable)", type: "text" },
        { id: "mcs_product_cert", label: "MCS product certification number (if applicable)", type: "text" },
        { id: "fgas_cert", label: "F-gas certification number (if applicable)", type: "text" },
      ]},
      { title: "Electrical and Hydronic Controls", fields: [
        { id: "ctrl_time_temp_heating", label: "Time and temperature control to heating", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_prog_roomstat", label: "Programmable Roomstat", type: "checkbox" },
        { id: "ctrl_load_weather", label: "Load/weather compensation", type: "checkbox" },
        { id: "ctrl_optimum_start", label: "Optimum start control", type: "checkbox" },
        { id: "ctrl_time_temp_hw", label: "Time and temperature control to hot water", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_combined_hp", label: "Combined with Heat pump main controls", type: "checkbox" },
      ]},
      { title: "Zone Valves & Components", fields: [
        { id: "heating_zone_status", label: "Heating zone valves (including underfloor loops)", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hw_zone_status", label: "Hot water zone valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "trv_status", label: "Thermostatic radiator valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "outdoor_sensor_status", label: "Outdoor Sensor", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hp_safety_interlock", label: "Heat Pump Safety Interlock", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "auto_bypass_status", label: "Automatic bypass to system", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "buffer_vessel", label: "Buffer Vessel Fitted", type: "select", options: ["Yes", "No"] },
        { id: "buffer_vessel_volume", label: "Buffer vessel volume (Litres)", type: "text" },
        { id: "expansion_vessel", label: "Expansion vessel sized, fitted & charged per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "legionella_protection", label: "Legionella protection for stored hot water provided by timed temperature control?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Water Treatment — Heating System", fields: [
        { id: "system_cleaned_bs7593", label: "System cleaned and treated per BS 7593:2019 and manufacturer's instructions?", type: "select", options: ["Yes", "No"] },
        { id: "system_cleaner_brand", label: "System cleaner — Brand", type: "text" },
        { id: "system_cleaner_product", label: "System cleaner — Product", type: "text" },
        { id: "inhibitor_brand", label: "Heating system inhibitor — Brand", type: "text" },
        { id: "inhibitor_product", label: "Heating system inhibitor — Product", type: "text" },
        { id: "system_filter_bs7593", label: "System filter fitted in accordance with BS7593:2019?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Central Heating Mode", fields: [
        { id: "ch_filled_tested", label: "Heating system has been filled and pressure tested", type: "select", options: ["Yes", "No"] },
        { id: "ch_flow_temp", label: "Heating Flow Temperature (°C)", type: "text" },
        { id: "ch_return_temp", label: "Heating Return Temperature (°C)", type: "text" },
        { id: "ch_source_inlet_temp", label: "Source inlet temperature (°C)", type: "text" },
        { id: "ch_source_outlet_temp", label: "Source outlet temperature (°C)", type: "text" },
        { id: "ch_cop_measured", label: "Measured COP (if available)", type: "text" },
        { id: "ch_balanced", label: "System correctly balanced/rebalanced", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Domestic Hot Water Mode", fields: [
        { id: "dhw_cylinder_type", label: "Is the heat pump connected to a hot water cylinder?", type: "select", options: ["Unvented", "Vented", "Thermal Store", "Not connected"] },
        { id: "dhw_cylinder_size", label: "Hot water cylinder size (Litres)", type: "text" },
        { id: "dhw_stored_temp", label: "Stored hot water temperature (°C)", type: "text" },
        { id: "dhw_checked_all_outlets", label: "Hot water has been checked at all outlets", type: "select", options: ["Yes", "No"] },
        { id: "dhw_blending_valves", label: "Have Thermostatic Blending Valves been fitted?", type: "select", options: ["Yes", "Not required"] },
      ]},
      { title: "All Installations — Compliance Declarations", fields: [
        { id: "decl_electrical", label: "All electrical work complies with the appropriate Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "Heat pump and associated products installed and commissioned per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation of heat pump and system controls demonstrated to and understood by customer", type: "select", options: ["Yes", "No"] },
        { id: "decl_literature", label: "Manufacturer's literature, including Benchmark Checklist and Service Record, explained and left with customer", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Service Record 1", fields: [
        { id: "svc1_engineer", label: "Engineer name", type: "text" },
        { id: "svc1_company", label: "Company name", type: "text" },
        { id: "svc1_telephone", label: "Telephone No", type: "text" },
        { id: "svc1_operative_id", label: "Operative ID No", type: "text" },
        { id: "svc1_date", label: "Date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "svc1_inhibitor_checked", label: "System inhibitor concentration checked and appropriate action taken per BS 7593", type: "select", options: ["Yes", "N/a"] },
        { id: "svc1_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "mcs-hybrid-hp-benchmark": {
    type: "hybrid_hp_benchmark",
    title: "Hybrid Heat Pump (Gas + ASHP) Commissioning Benchmark",
    description: "Benchmark commissioning checklist for combined gas boiler and air source heat pump systems",
    sections: [
      { title: "Installation Address & System Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "hp_type", label: "Heat Pump Type", type: "select", options: ["Split", "Monoblock"] },
        { id: "boiler_make_model", label: "Gas Boiler make and model", type: "text" },
        { id: "boiler_serial_number", label: "Gas Boiler serial number", type: "text" },
        { id: "boiler_type", label: "Boiler type", type: "select", options: ["Combi", "System", "Heat only"] },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "cert_operative_reg", label: "Certified Operative Reg number", type: "text" },
        { id: "gas_safe_reg", label: "Gas Safe Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Hybrid System Controls", fields: [
        { id: "ctrl_hybrid_controller", label: "Hybrid controller / energy manager installed", type: "checkbox" },
        { id: "ctrl_hybrid_switching", label: "Switching point — Temperature Level (°C) or Tariff", type: "text" },
        { id: "ctrl_boiler_priority", label: "Boiler takes priority above switching point", type: "checkbox" },
        { id: "ctrl_hp_priority", label: "Heat pump takes priority below switching point", type: "checkbox" },
        { id: "ctrl_weather_comp", label: "Weather compensation active on heat pump", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_outdoor_sensor", label: "Outdoor sensor fitted", type: "checkbox" },
        { id: "ctrl_boiler_interlock", label: "Boiler interlock provided", type: "checkbox" },
      ]},
      { title: "Gas Boiler Commissioning", fields: [
        { id: "gas_rate", label: "Gas rate (m³/hr)", type: "text" },
        { id: "gas_inlet_pressure", label: "Gas inlet pressure (mbar)", type: "text" },
        { id: "co_max_ppm", label: "CO at max rate (ppm)", type: "text" },
        { id: "co2_max", label: "CO₂ at max rate (%)", type: "text" },
        { id: "co_ratio", label: "CO/CO₂ ratio", type: "text" },
        { id: "boiler_flow_temp", label: "Boiler flow temperature (°C)", type: "text" },
        { id: "boiler_return_temp", label: "Boiler return temperature (°C)", type: "text" },
        { id: "flue_condition", label: "Flue condition satisfactory", type: "select", options: ["Yes", "No"] },
        { id: "gas_tightness", label: "Gas tightness satisfactory", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Heat Pump Commissioning", fields: [
        { id: "hp_ch_flow_temp", label: "HP Flow Temperature (°C)", type: "text" },
        { id: "hp_ch_return_temp", label: "HP Return Temperature (°C)", type: "text" },
        { id: "frost_protected", label: "Pipes insulated to prevent heat loss?", type: "select", options: ["Yes", "No"] },
        { id: "fan_clear", label: "Fan free from obstacles and operational", type: "select", options: ["Yes", "No"] },
        { id: "condensate_drain", label: "Condensate drain installed", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "All Installations — Declarations", fields: [
        { id: "decl_electrical", label: "Electrical work complies with Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_gas_safe", label: "Gas installation complies with Gas Safety Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "System installed per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation demonstrated to customer", type: "select", options: ["Yes", "No"] },
        { id: "decl_literature", label: "Literature explained and left with customer", type: "select", options: ["Yes", "No"] },
      ]},
    ],
  },
};